module.exports = __webpack_public_path__ + "static/media/amm4.e791b945.jpg";